"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IteroEventBus = void 0;
var eventInfo_1 = require("./eventInfo");
var eventSchema_service_1 = require("./eventSchema.service");
var timber_service_1 = require("./timber.service");
var itero_event_bus_1 = require("@itero/itero-event-bus");
var consts_1 = require("@itero/itero-event-bus/consts");
var systemheader = __importStar(require("./eventSchemas/systemHeader/systemheader.json"));
var basesystemheader = __importStar(require("./eventSchemas/systemHeader/basesystemheader.json"));
var IteroEventBus = /** @class */ (function () {
    function IteroEventBus(loggingEndpoint) {
        this.validChannelName = [consts_1.ChannelName.platformChannel, consts_1.ChannelName.applicationChannel];
        this.timberService = new timber_service_1.TimberService(loggingEndpoint);
        this.eventBus = new itero_event_bus_1.EventBus(loggingEndpoint, [basesystemheader, systemheader]);
    }
    IteroEventBus.prototype.on = function (channelName, callbackAppId, callbackFunc) {
        return this.eventBus.on(channelName, callbackAppId, callbackFunc);
    };
    IteroEventBus.prototype.emit = function (channelName, publisherAppId, eventName, eventId, targetApplications, eventPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var logParams, eventSchemeExists, eventSchema;
            return __generator(this, function (_a) {
                logParams = { module: 'emit', extendedParameters: { eventId: eventId, channelName: channelName, publisherAppId: publisherAppId, eventName: eventName, sessionId: this.eventBus.sessionId } };
                if (this.validateChannel(channelName, eventName, logParams)) {
                    eventSchemeExists = eventSchema_service_1.EventSchemaService.Schemes.has(eventName);
                    if (eventSchemeExists) {
                        eventSchema = eventSchema_service_1.EventSchemaService.Schemes.get(eventName);
                        return [2 /*return*/, this.eventBus.emit(channelName, publisherAppId, eventName, eventSchema, eventId, targetApplications, eventPayload)];
                    }
                    this.timberService.error("Failed to found event schema for ".concat(eventName), logParams);
                }
                return [2 /*return*/, false];
            });
        });
    };
    IteroEventBus.prototype.unsubscribe = function (channelName, appIdToUnsubscribe) {
        this.eventBus.unsubscribe(channelName, appIdToUnsubscribe);
    };
    IteroEventBus.prototype.generateEventId = function () {
        return this.eventBus.generateEventId();
    };
    IteroEventBus.prototype.setRegion = function (region) {
        this.eventBus.region = region;
    };
    IteroEventBus.prototype.getRegion = function () {
        return this.eventBus.region;
    };
    IteroEventBus.prototype.setSessionId = function (sessionId) {
        this.eventBus.sessionId = sessionId;
    };
    IteroEventBus.prototype.getSessionId = function () {
        return this.eventBus.sessionId;
    };
    IteroEventBus.prototype.validateChannel = function (channelName, eventName, logParams) {
        if (this.validChannelName.includes(channelName)) {
            if (channelName === consts_1.ChannelName.platformChannel) {
                if (eventInfo_1.PlatformChannelEvents.includes(eventName))
                    return true;
            }
            else if (channelName === consts_1.ChannelName.applicationChannel) {
                if (eventInfo_1.ApplicationChannelEvents.includes(eventName))
                    return true;
            }
            this.timberService.error('Channel ' + channelName + ' is not supported with event ' + eventName, logParams);
        }
        else {
            this.timberService.error('Channel ' + channelName + ' is not supported.', logParams);
        }
        return false;
    };
    return IteroEventBus;
}());
exports.IteroEventBus = IteroEventBus;
__exportStar(require("./public-interfaces"), exports);
